import {
  Box,
  FormControlLabel,
  Grid2,
  Radio,
  RadioGroup,
  SxProps,
  Theme,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React, { SetStateAction } from 'react';
import { AppointmentType as DBAppointmentType } from '@prisma/client';
import BlockOutlined from '@mui/icons-material/BlockOutlined';
import { SvgIconComponent } from '@mui/icons-material';

interface Props {
  value: (DBAppointmentType | 'TIME_BLOCK') | undefined;
  setFieldValue: (
    value: SetStateAction<DBAppointmentType | 'TIME_BLOCK' | undefined>,
  ) => void;
}

const OPTION_SX: SxProps<Theme> = {
  ':hover': {
    bgcolor: theme => theme.palette.lightGrey.main,
  },
  transition: 'background-color 0.3s',
};

export default function AppointmentType({ value, setFieldValue }: Props) {
  const isDesktop = useMediaQuery('(min-width:900px)');

  function labelMaker(method: string) {
    let src: string | SvgIconComponent = '';
    let labelName = '';
    let labelDesc = '';

    switch (method) {
      case 'NEW_APPOINTMENT':
        src = '/calendar.svg';
        labelName = 'Add an Appointment';
        labelDesc = 'Schedule an appointment with a client';
        break;
      case 'WALK_IN':
        src = '/walk.svg';
        labelName = 'Add a Walk-In';
        labelDesc = 'Add a walk-in customer';
        break;
      case 'CONSULTATION':
        src = '/consultation.svg';
        labelName = 'Add a Consultation';
        labelDesc = 'Schedule a consultation with a client';
        break;
      case 'TIME_BLOCK':
        src = BlockOutlined;
        labelName = 'Add a time block';
        labelDesc = 'Block off time in your calendar';
        break;
      default:
        src = '';
        labelName = '';
    }

    const Icon =
      typeof src === 'string' ? React.Fragment : (src as SvgIconComponent);

    return (
      <Box className="appointment-type-label">
        {typeof src === 'string' ? (
          <img src={src} alt="" className="appointment-type-icon" />
        ) : (
          <Icon
            sx={{
              fontSize: 75,
            }}
          />
        )}
        <div className="appointment-type-label-text">
          <Typography variant="h3" align="center" style={{ marginBottom: 2 }}>
            {labelName}
          </Typography>
          <Typography variant="body2" align="center">
            {labelDesc}
          </Typography>
        </div>
      </Box>
    );
  }

  return (
    <Box
      className="input-group"
      style={{
        display: 'flex',
        alignItems: isDesktop ? 'flex-start' : 'center',
      }}>
      <Typography variant="h2">What do you want to create?</Typography>
      <RadioGroup
        aria-labelledby="radio-appointment-type"
        name="appointmentType"
        id="appointment-type-radio-group"
        value={value}
        onChange={(_event, newVal) =>
          setFieldValue(newVal as DBAppointmentType)
        }>
        <Grid2 container spacing={2} columns={12}>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <FormControlLabel
              value="WALK_IN"
              control={
                <Radio inputProps={{ className: 'radio-appointment-type' }} />
              }
              label={labelMaker('WALK_IN')}
              className={`appointment-type-label ${
                value === 'WALK_IN' ? 'checked' : ''
              }`}
              sx={OPTION_SX}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <FormControlLabel
              value="NEW_APPOINTMENT"
              control={
                <Radio inputProps={{ className: 'appointment-type-method' }} />
              }
              label={labelMaker('NEW_APPOINTMENT')}
              className={`appointment-type-label ${
                value === 'NEW_APPOINTMENT' ? 'checked' : ''
              }`}
              sx={OPTION_SX}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <FormControlLabel
              value="CONSULTATION"
              control={
                <Radio inputProps={{ className: 'appointment-type-method' }} />
              }
              label={labelMaker('CONSULTATION')}
              className={`appointment-type-label ${
                value === 'CONSULTATION' ? 'checked' : ''
              }`}
              sx={OPTION_SX}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <FormControlLabel
              value="TIME_BLOCK"
              control={
                <Radio inputProps={{ className: 'appointment-type-method' }} />
              }
              label={labelMaker('TIME_BLOCK')}
              className={`appointment-type-label ${
                value === 'TIME_BLOCK' ? 'checked' : ''
              }`}
              sx={OPTION_SX}
            />
          </Grid2>
        </Grid2>
      </RadioGroup>
    </Box>
  );
}
